import { render, staticRenderFns } from "./ItemDropdown.vue?vue&type=template&id=f089ee70&scoped=true"
import script from "./ItemDropdown.vue?vue&type=script&lang=js"
export * from "./ItemDropdown.vue?vue&type=script&lang=js"
import style0 from "./ItemDropdown.vue?vue&type=style&index=0&id=f089ee70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f089ee70",
  null
  
)

export default component.exports